import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_API_URL;

axios.defaults.baseURL = BACKEND_URL;
axios.defaults.headers.common = {
  'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json',
};

type Response = {
  error: boolean;
  message?: unknown;
  data?: unknown;
};

const getToken = (): string | undefined => {
  const tokenString = sessionStorage.getItem('token');

  return tokenString !== null ? atob(tokenString) : undefined;
};

export class FireDepartmentService {
  static async getAllFireDepartments(): Promise<Response> {
    const token = getToken();

    return new Promise((resolve) => {
      axios
        .get(`/v1/firedepartment`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          resolve({ error: false, data: response.data });
        })
        .catch((error) => {
          resolve({ error: true, message: error });
        });
    });
  }

  static async getFireDepartmentById(fireDepartmentId: string): Promise<Response> {
    const token = getToken();

    return new Promise((resolve) => {
      axios
        .get(`/v1/firedepartment/${fireDepartmentId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          resolve({ error: false, data: response.data });
        })
        .catch((error) => {
          resolve({ error: true, message: error });
        });
    });
  }

  static async addFireDepartment(fireDepartmentName: string): Promise<Response> {
    const token = getToken();

    return new Promise((resolve) => {
      axios
        .post(
          '/v1/firedepartment',
          { name: fireDepartmentName },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          resolve({ error: false, data: response.data });
        })
        .catch((error) => {
          resolve({ error: true, message: error });
        });
    });
  }
}
